class LetoileCatalog {
  constructor(root = document) {
    this.catalogs = [...root.querySelectorAll('[data-catalog-mobile]')].filter((catalog) => !catalog.dataset.catalogBound);
    this.catalogs.forEach((catalog) => this.bind(catalog));
  }

  bind(catalog) {
    catalog.dataset.catalogBound = 'true';
    this.headerBack = document.querySelector('[data-catalog-header-back]');
    catalog.addEventListener('click', (event) => {
      const open = event.target.closest('[data-catalog-open]');
      if (open) {
        this.show(catalog, open.dataset.catalogOpen, open);
        return;
      }

      const back = event.target.closest('[data-catalog-back]');
      if (back) this.show(catalog, back.dataset.catalogBack, back);
    });
    if (this.headerBack && !this.headerBack.dataset.catalogBackBound) {
      this.headerBack.dataset.catalogBackBound = 'true';
      this.headerBack.addEventListener('click', () => {
        const current = catalog.querySelector('[data-catalog-panel]:not([hidden])');
        const parentId = current?.dataset.catalogParent;
        if (parentId) {
          this.show(catalog, parentId, this.headerBack);
          return;
        }

        if (window.history.length > 1) {
          window.history.back();
        } else {
          window.location.assign(this.headerBack.dataset.catalogRootUrl || '/');
        }
      });
    }
  }

  show(catalog, panelId, trigger) {
    const current = catalog.querySelector('[data-catalog-panel]:not([hidden])');
    const next = catalog.querySelector(`[data-catalog-panel="${CSS.escape(panelId || '')}"]`);
    if (!next || next === current) return;

    if (current) current.dataset.catalogScrollY = String(window.scrollY);
    current?.setAttribute('hidden', '');
    next.removeAttribute('hidden');
    this.headerBack?.setAttribute('data-catalog-level', next.dataset.catalogLevel || '1');

    catalog.querySelectorAll('[data-catalog-open]').forEach((button) => {
      button.setAttribute('aria-expanded', button === trigger ? 'true' : 'false');
    });

    const restoreY = Number(next.dataset.catalogScrollY || 0);
    window.requestAnimationFrame(() => {
      window.scrollTo({ top: restoreY, behavior: 'auto' });
      next.querySelector('h2, [data-catalog-panel-heading]')?.focus({ preventScroll: true });
    });
  }
}

new LetoileCatalog();
document.addEventListener('shopify:section:load', (event) => new LetoileCatalog(event.target));
